export default __webpack_public_path__ + "static/media/p_wdt_c_4.07f33fee.mp3";